import { db } from "../../firebase/firebase";

export const GETPAYSTUBS = "GETPAYSTUBS";
export const GETPAYSTUBSERR = "GETPAYSTUBSERR";

export function getStartPayStubs(id) {
  return async dispatch => {
    db.collection("paystubs")
      .where("employeeUid", "==", id)
      .onSnapshot(
        function(querySnapshot) {
          let datatoStore = [];
          querySnapshot.forEach(function(doc) {
            const data = doc.data();
            const id = doc.id;
            datatoStore.push({ id, ...data });
          });
           
          dispatch({
            type: GETPAYSTUBS,
            payload: datatoStore
          });
        },
        function(error) {
          dispatch({
            type: GETPAYSTUBSERR,
            payload: new Date()
          });
        }
      );
  };
}
